import { render, staticRenderFns } from "./DialogValidateBomlist.vue?vue&type=template&id=5740017c"
import script from "./DialogValidateBomlist.vue?vue&type=script&lang=js"
export * from "./DialogValidateBomlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports